<app-header [diviceXs]="diviceXs" [diviceSm]="diviceSm"></app-header>

<app-loader></app-loader>

<mat-drawer-container class="example-container" [hasBackdrop]="true" fxShow="false" fxShow.sm="true" fxShow.xs="true">
  <mat-drawer #sidenav mode="over">
    <app-menu [menuMobile]="true"></app-menu>
  </mat-drawer>
  <mat-drawer-content>
    <router-outlet name="sidebar" *ngIf="diviceXs || diviceSm"></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>

<router-outlet *ngIf="!diviceXs && !diviceSm"></router-outlet>

<app-footer></app-footer>
